export const environment = {
  production: false,
  mode: 'dev'
};
